export interface FormLabel {
  name?: string;
  tooltip?: string;
  id?: string;
  key?: string;
  labels: string[];
  uid?: string;
  mandatory?:boolean
}

export interface IGenericFormLoader {
  decisionKey?:string;
  defaultFormData:any;
  submitedFormData:any;
  readOnly?:boolean;
}
